import {client, database_id} from "../lib/appwrite";
import {v4 as uuidv4} from "uuid";
import {CorrectDepartmentItem} from "../types/department";
import {Databases, Query} from "appwrite";

const DEPARTMENTS_COLLECTION_ID = "678400570009737f8e51"

const databases = new Databases(client);

export const departmentsService = {
  async list(queries: string[] = [], limit: number = 25): Promise<CorrectDepartmentItem[]> {
    try {
      const response = await databases.listDocuments(
        database_id,
        DEPARTMENTS_COLLECTION_ID,
        [
          Query.limit(limit),
          ...queries
        ]
      );
      const departments = response.documents.map(doc => doc as unknown as CorrectDepartmentItem);
      return departments;
    } catch (error) {
      console.error('Error listing departments:', error);
      throw error;
    }
  },


  async updateDepartment(data: CorrectDepartmentItem): Promise<CorrectDepartmentItem> {
    try {
      const id = data.$id as string
      const {$id, ...correctData} = data
      const updatedDepartment = await databases.updateDocument(
        "6771098900254ec19571",
        "678400570009737f8e51",
        id,
        correctData
      ) as unknown as CorrectDepartmentItem;

      return updatedDepartment;
    } catch (error) {
      console.log(error)
      console.error('Помилка оновлення відділення:', error);
      throw error;
    }
  },

  async createDepartment(data: CorrectDepartmentItem): Promise<CorrectDepartmentItem> {
    try {
      const createdDepartment = await databases.createDocument(
        database_id,
        DEPARTMENTS_COLLECTION_ID,
        uuidv4(),
        data
      ) as unknown as CorrectDepartmentItem;

      return createdDepartment;
    } catch (error) {
      console.error('Помилка створення відділення:', error);
      throw error;
    }
  },

  async geDepartmentItem(id: string): Promise<CorrectDepartmentItem> {
    try {
      const current = await databases.getDocument(
        database_id,
        DEPARTMENTS_COLLECTION_ID,
        id
      ) as unknown as CorrectDepartmentItem;

      return current;
    } catch (error) {
      console.error('Помилка:', error);
      throw error;
    }
  },


  async delete(id: string): Promise<void> {
    try {
      // Зараз видаляю тільки саме відділення
      // але пізніше треба видалити кабінети/стафф/зображення
      await databases.deleteDocument(
        database_id,
        DEPARTMENTS_COLLECTION_ID,
        id
      );
    } catch (error) {
      console.error('Помилка видалення відділення:', error);
      throw error;
    }
  },
}